import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import * as dayjs from "dayjs";
import * as relativeTime from "dayjs/plugin/relativeTime";
import { PrefinishDTO } from "src/app/models/dto/prefinish.dto";

@Component({
  selector: "app-mant-modal-terminar",
  templateUrl: "./modal.component.html",
})
export class MantenimientoTerminarModal implements OnInit {
  _fecha: string = "";
  _tiempoDesde: string = "";
  _leido: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<MantenimientoTerminarModal>,
    @Inject(MAT_DIALOG_DATA) public data: PrefinishDTO
  ) {}
  public ngOnInit() {
    dayjs.extend(relativeTime);
    this._fecha = dayjs(this.data.Fecha).format("YYYY-MM-DD");
    this._tiempoDesde = dayjs(this.data.Fecha).fromNow();
  }

  public reasignar() {
    this.dialogRef.close({ option: "r" });
  }

  public terminar() {
    this.dialogRef.close({ option: "t" });
  }
}
